import PropTypes from 'prop-types';
import classNames from 'classnames';

const ItemHeading = ({ heading, url, level, onClick }) => {
  const headingClasses = classNames(
    'gw-tree-list-item__heading',
    `gw-tree-list-item__heading--level-${level}`,
  );

  if (url) {
    return (
      <span className="gw-tree-list-item__link">
        <div className={headingClasses}>
          <a href={url} onClick={(event) => onClick(event)}>
            {heading}
          </a>
        </div>
      </span>
    );
  }
  return (
    <div className={headingClasses}>
      <span>{heading}</span>
    </div>
  );
};

ItemHeading.propTypes = {
  heading: PropTypes.string.isRequired,
  url: PropTypes.string,
  level: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

ItemHeading.defaultProps = {
  url: null,
  onClick: () => {},
};

export default ItemHeading;
